module.exports = __webpack_public_path__ + "static/media/insulation@2x.de02fc47.jpg";